import { UploadFile } from 'antd/es/upload/interface';

// 上传文件的 File 对象及 base64 缩略图体积较大，无法被 history.state 可靠序列化；
// 一旦写入 history，（尤其浏览器原生）返回时该条 state 可能被浏览器丢弃，导致退回 step1 且表单数据丢失。
// 因此把上传文件单独缓存在内存里，history.state 只保存可序列化的其余字段，返回时再合并还原。

let claimFilesCache: Record<string, UploadFile[]> = {};

export const clearClaimFilesCache = (): void => {
  claimFilesCache = {};
};

const isUploadFileArray = (value: unknown): value is UploadFile[] =>
  Array.isArray(value) &&
  value.some(
    (item) =>
      item &&
      typeof item === 'object' &&
      ('originFileObj' in (item as Record<string, unknown>) ||
        (typeof (item as UploadFile).uid === 'string' && ((item as UploadFile).uid as string).startsWith('rc-upload'))),
  );

// 提取并缓存上传文件，返回可安全存入 history.state 的其余表单数据
export const extractFilesForHistory = <T extends Record<string, unknown>>(values: T): T => {
  const serializable: Record<string, unknown> = {};
  Object.entries(values).forEach(([key, value]) => {
    if (isUploadFileArray(value)) {
      claimFilesCache[key] = value;
    } else {
      serializable[key] = value;
    }
  });
  return serializable as unknown as T;
};

// 读取缓存中仍有文件的上传字段，用于返回时还原
export const getCachedFiles = (): Record<string, UploadFile[]> => {
  const files: Record<string, UploadFile[]> = {};
  Object.entries(claimFilesCache).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) files[key] = value;
  });
  return files;
};

// 把缓存中的文件合并到目标对象，返回完整数据（用于 ClaimConfirmPage 等消费端还原）
export const mergeCachedFiles = <T>(data: T): T => {
  const cached = getCachedFiles();
  if (Object.keys(cached).length === 0) return data;
  return { ...(data as Record<string, unknown>), ...cached } as unknown as T;
};
